<template>
    <span>
      <slot></slot>
    </span>
</template>

<script>
  import StoreApi from '../../api/StoreApi';
  import ProductApi from '../../api/ProductApi';

  export default {
    name: "EmpresaContainer",
    data(){
      return{
        empresaExiste:false,
        dias:[]
      }
    },
    mounted()
    {
      this.isLoading = true;
      if(this.$store.state.empresa_url == this.$router.currentRoute.params.empresa)
      {
        if(this.$store.state.produtos.length > 0){
          this.empresaExiste = true;
        }else{
          this.VerificarEmpresa();
        }
      }else{
        this.VerificarEmpresa();
      }
    },
    methods:{
      async VerificarEmpresa()
      {
        this.$store.commit('empresaUrl',this.$router.currentRoute.params.empresa);

        await StoreApi.getStore(this.$store.state.empresa_url).then(res=>{

            this.$store.commit('empresa',res);
            this.$store.state.empresa.horarios.filter(number => {
              this.dias.push(number.dia)
            });
            this.$store.commit('dias',this.dias);
            this.empresaExiste = true;

        }).catch(error =>{
            console.log(error)
            console.log('erro');
        });


        if(this.empresaExiste) {
          this.obterProdutos();
          this.$store.commit('empresaVerificada',true);
        }else{
          this.$router.push('/404/nao-localizado/' + this.$router.currentRoute.params.empresa)
        }
      },
      async obterProdutos()
      {
        await ProductApi.getProducts(this.$store.state.empresa_url).then(res=>{

          let grupos=[];
          $.each(res.data.grupos, function(key, value) {
            grupos.push(value);
          });

          if(this.$store.state.empresa.tipo_ordenacao_grupo != "LIVRE"){
            grupos.sort((a,b) => (a.grupo.nome > b.grupo.nome) ? 1 : ((b.grupo.nome > a.grupo.nome) ? -1 : 0));
          }else{
            grupos.sort((a,b) => (a.grupo.posicao > b.grupo.posicao) ? 1 : ((b.grupo.posicao > a.grupo.posicao) ? -1 : 0));
          }

          for (let i = 0; i < grupos.length;i++)
          {
            let secoes=[];
            $.each( grupos[i].secoes, function(key, value) {
              secoes.push(value);
            });

            if(this.$store.state.empresa.tipo_ordenacao_secao != "LIVRE"){
              secoes.sort((a,b) => (a.detalhes.nome > b.detalhes.nome) ? 1 : ((b.detalhes.nome > a.detalhes.nome) ? -1 : 0));
            }else{
              secoes.sort((a,b) => (a.detalhes.posicao > b.detalhes.posicao) ? 1 : ((b.detalhes.posicao > a.detalhes.posicao) ? -1 : 0));
            }

            grupos[i].secoes = secoes;
          }

          // this.$store.commit('grupos',res.data.grupos)
          this.$store.commit('grupos',grupos)
          this.$store.commit('produtosPromocao',res.data.promocoes)

          if(JSON.stringify(res.data.promocoes) != "[]"){
            this.$store.commit('produtosPromocaoBool',true)
          }

          this.$store.commit('grupoPromocional',res.data.grupo_promocional)
          var ls = this.$SecureLS;
          ls.set('gruposSecoesPromocoes',res.data);

        }).catch(error =>{
            console.log(error)
            console.log('erro');
        });

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/EmpresaContainer.vue